/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteOrganizationUserSessionIssuerCimdClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteOrganizationUserSessionIssuerCimdClientRequest = {
  /**
   * The user_session_issuer_cimd_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DeleteOrganizationUserSessionIssuerCimdClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteOrganizationUserSessionIssuerCimdClientSecurity$outboundSchema:
  z.ZodMiniType<
    DeleteOrganizationUserSessionIssuerCimdClientSecurity$Outbound,
    DeleteOrganizationUserSessionIssuerCimdClientSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteOrganizationUserSessionIssuerCimdClientSecurityToJSON(
  deleteOrganizationUserSessionIssuerCimdClientSecurity:
    DeleteOrganizationUserSessionIssuerCimdClientSecurity,
): string {
  return JSON.stringify(
    DeleteOrganizationUserSessionIssuerCimdClientSecurity$outboundSchema.parse(
      deleteOrganizationUserSessionIssuerCimdClientSecurity,
    ),
  );
}

/** @internal */
export type DeleteOrganizationUserSessionIssuerCimdClientRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteOrganizationUserSessionIssuerCimdClientRequest$outboundSchema:
  z.ZodMiniType<
    DeleteOrganizationUserSessionIssuerCimdClientRequest$Outbound,
    DeleteOrganizationUserSessionIssuerCimdClientRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function deleteOrganizationUserSessionIssuerCimdClientRequestToJSON(
  deleteOrganizationUserSessionIssuerCimdClientRequest:
    DeleteOrganizationUserSessionIssuerCimdClientRequest,
): string {
  return JSON.stringify(
    DeleteOrganizationUserSessionIssuerCimdClientRequest$outboundSchema.parse(
      deleteOrganizationUserSessionIssuerCimdClientRequest,
    ),
  );
}
